module.exports = __webpack_public_path__ + "img/BlinkArt_Sword5_Red.53e321da.png";